var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookDesktopMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M0 1.999C0 .895.902 0 2.009 0H9.99C11.101 0 12 .892 12 1.999v6.058a2 2 0 0 1-1.995 1.999H6.25L3.5 12.25H3v-2.194h-.999A2 2 0 0 1 0 8.057z"
})));
export default SvgFacebookDesktopMessage;